<mat-sidenav-container class="sidenav authorization-scheme-filter">
  <mat-sidenav #sidenav [opened]="model.open" mode="over" fixedInViewport="true" position="end">
    <div fxFlex="100" fxLayout="column">

      <!-- Header -->
      <div [ngClass]="{'mat-card': isScrolled}" class="sidenav-header" fxLayout="row"
        fxLayoutAlign="space-between center">

        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="icon-back c-pointer" aria-label="Back" (click)="close()" fxLayout="row"
            fxLayoutAlign="center center">
            <mat-icon class="arrow-left">keyboard_arrow_left</mat-icon>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">

            <div (click)="close()" class="title" *ngIf="state != 'add'"> {{ 'authorization.title' | translate }}</div>
            <div (click)="close()" class="title" *ngIf="state == 'add'"> {{ 'authorization.title_add' | translate }}
            </div>

          </div>
        </div>

        <div fxLayoutAlign="center center" class="close h-medium c-pointer" (click)="close()">
          <mat-icon>close</mat-icon>
        </div>

      </div>

      <!-- Content -->
      <div (scroll)="onContentScroll($event);" class="sidenav-content filter-content" fxFlex>

        <mat-card appearance="outlined" class="card-edit">

          <mat-card-header fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
            <mat-card-title fxLayout="row" fxLayoutAlign="start center">
              <span [ngClass]="{'scheme-name': state === 'read_only', 'scheme-name-edit': state !== 'read_only'}" #name>
                {{ model.authorization_scheme?.name }}
              </span>

              @if (state != 'read_only') {
              <mat-form-field class="add-name" *ngIf="name.hidden">
                <input autoSizeInput matInput [hidden]="!name.hidden" [(ngModel)]="model.authorization_scheme.name"
                  #edit (keyup.enter)="inputNameKeyupEnter($event)">
              </mat-form-field>

              <button class="btn-edit" fxLayout="row" fxLayoutAlign="center center"
                (click)="editStep($event); name.hidden = false" mat-icon-button *ngIf="name.hidden">
                <mat-icon class="icon-edit" svgIcon="icon_check"></mat-icon>
              </button>

              <button class="btn-edit" fxLayout="row" fxLayoutAlign="center center" mat-icon-button
                (click)="name.hidden = true; clickEditName()" *ngIf="!name.hidden">
                <mat-icon class="icon-edit" svgIcon="icon_edit"></mat-icon>
              </button>

              }
            </mat-card-title>
            <!-- @if(model.has_test_ab){
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
              <div fxHide.lt-md class="test-ab">
                {{ 'authorization.test_ab_message' | translate }}
              </div>
              <div fxLayoutAlign="center center">
                <mat-icon class="icon_experiment-header" svgIcon="icon_experiment"></mat-icon>
              </div>
            </div>
            } -->

          </mat-card-header>

          <mat-card-content>

            <div class="auth-scheme" fxLayout="column">
              <div class="auth-scheme-row" fxLayout="column"
                *ngFor="let step of model.authorization_scheme?.steps; let first = first; let last = last;">

                <!-- Connection Columns -->
                <div class="content-edit" fxLayout="row" fxFlex fxLayoutAlign="start start" fxLayout.lt-md="row wrap">

                  @if (state == 'read_only') {

                  <!-- Connection Column Template -->
                  <ng-container id="step.id"
                    *ngFor="let connection of [step.first_service, step.second_service, step.third_service]">
                    <div class="col" fxFlex="20" fxFlex.lt-md="50" fxLayout="column">
                      <div class="title-step fc-9 mb-3">
                        <div *ngIf="connection === step.first_service">{{ 'authorization.attempt' | translate }}</div>
                        <div *ngIf="connection === step.second_service">{{ 'authorization.retry' | translate }}</div>
                        <div *ngIf="connection === step.third_service">{{ 'authorization.second_retry' | translate }}
                        </div>
                      </div>
                      <div class="item-selected" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px"
                        *ngIf="connection?.id">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                          *ngIf="connection.image_path">
                          <img class="connection-logo" [src]="connection.image_path">
                        </div>
                        <div class="fs-14 fc-6">{{ connection.custom_name }}</div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Traffic Column -->

                  <div class="col" fxFlex="20" fxFlex fxFlex.lt-md="50" fxLayout="column">
                    <div class="title-step fc-9 mb-3">
                      <div>
                        {{ 'authorization.traffic' | translate }}
                      </div>
                    </div>
                    <div class="allocation-input" fxLayout="column" fxFlex="100">
                      <span class="percentage">{{ step.percentage }}%</span>
                    </div>
                  </div>
                  }
                  @if(state == 'add' || state == 'editing') {

                  <ng-container *ngFor="let serviceType of ['first', 'second', 'third']; let i = index">
                    <div class="col" fxFlex="20" fxFlex.lt-md="50" fxLayout="column">
                      <div class="title-step fc-9 mb-3">
                        <div *ngIf="serviceType === 'first'">{{ 'authorization.attempt' | translate }}</div>
                        <div *ngIf="serviceType === 'second'">{{ 'authorization.retry' | translate }}</div>
                        <div *ngIf="serviceType === 'third'">{{ 'authorization.second_retry' | translate }}</div>
                      </div>
                      <app-connection-selector [connection]="step[serviceType + '_service']" id="{{step.id}}_{{i}}"
                        [canEdit]="model.authorization_scheme.can_edit"
                        (addConnection)="addConnection(step, serviceType, $event)"
                        (removeConnection)="removeConnection(step, serviceType)"></app-connection-selector>
                    </div>

                  </ng-container>


                  <div class="col" fxFlex fxLayout="column">
                    <mat-form-field class="allocation-input" hideRequiredMarker="true">
                      <input #allocationField matInput type="number" autoSizeInput [(ngModel)]="step.percentage"
                        maxlength="100" minlength="0" (keyup)="valid()">
                      <span class="percentage">%</span>
                    </mat-form-field>

                    <div class="allocation-slider" fxLayout="column" fxFlex="100">
                      <mat-slider color="primary" [max]="max" [min]="min" [step]="step" [discrete]="thumbLabel"
                        fxFlex="100" [showTickMarks]="showTicks">
                        <input matSliderThumb [(ngModel)]="step.percentage" #slider (change)="valid()">
                      </mat-slider>
                    </div>

                    <div class="ruler fs-10 fc-9" fxLayout="row" fxLayoutAlign="space-between center">
                      <div fxFlex class="stick" fxLayoutAlign="start center">
                        <div>0%</div>
                      </div>
                      <div fxFlex class="stick" fxLayoutAlign="start center">
                        <div>20%</div>
                      </div>
                      <div fxFlex class="stick" fxLayoutAlign="start center">
                        <div>40%</div>
                      </div>
                      <div fxFlex class="stick" fxLayoutAlign="start center">
                        <div>60%</div>
                      </div>
                      <div fxFlex class="stick" fxLayoutAlign="start center">
                        <div>80%</div>
                      </div>
                      <div fxFlex class="stick last" fxLayoutAlign="start center">
                        <div>100%</div>
                      </div>
                    </div>

                    <div class="allocation-validation" fxFlex>
                      <div class="validation-error fc-red fs-12 text-right" fxLayout="row" fxLayoutAlign="end center"
                        *ngIf="canShowErrorSum && last">
                        {{ 'authorization.actions.error' | translate}}
                      </div>
                    </div>
                  </div>

                  <div class="icons-edit col pl-2" fxFlex="20" fxLayout="row" fxLayoutAlign="start center">
                    <div class="ml-4" fxLayout="column">
                      <button mat-mini-fab disableRipple class="icon-button" fxLayout="row"
                        fxLayoutAlign="center center" (click)="removeRow(step)" *ngIf="!first t">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </div>


                    <div class="ml-4" fxLayout="column">
                      <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                        (click)="addRow()" *ngIf="last">
                        <button mat-mini-fab disableRipple class="icon-button" fxLayout="row"
                          fxLayoutAlign="center center">
                          <mat-icon>add</mat-icon>
                        </button>
                        <div class="fc-9">{{ 'authorization.addNewRow' | translate }}</div>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                <div class="hr" *ngIf="!last">
                  <hr>
                </div>
              </div>
            </div>



            <ng-container *ngIf="model.authorization_scheme?.flows?.length > 0">

              @if(state == 'read_only' || state == 'editing'){
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxFlex="100" fxLayout="row" fxLayoutGap="20px" fxLayoutGap.lt-md="15px"
                      fxLayoutAlign="start center">
                      <div fxLayoutAlign="center center">
                        <mat-icon svgIcon="icon_flows" class="flows-icon"></mat-icon>
                      </div>
                      <div class="title-box">{{ 'authorization.flows_part_of' | translate }}</div>
                    </div>
                    <div fxHide.lt-md fxLayout="row" fxLayoutAlign="start center"
                      [ngClass]="{'live-badge': true, 'active': model.authorization_scheme.active_flows > 0}">
                      <div class="live">
                        <div class="bullet" [ngClass]="{'success': model.authorization_scheme.active_flows > 0}"></div>
                      </div>
                      <span>{{ 'authorization.live' | translate }}</span>
                      <span class="separator">|</span>
                      <span>{{model.authorization_scheme.active_flows}}</span>
                    </div>
                  </div>

                </mat-expansion-panel-header>
                <div class="card-edit">
                  <div fxFlex="100" fxLayout="column">

                    @for(flow_version of model.authorization_scheme.flows; let idx = $index;
                    track
                    flow_version.id)
                    {
                    <div class="card-list-item" fxLayout="row" fxLayoutAlign="space-between">
                      <div class="flow-name">
                        {{ flow_version.flow.name}} -
                        {{ flow_version.flow.description}}
                      </div>

                      <div fxLayout="row" fxLayoutGap="15px" fxLayoutGap.lt-md="5px" fxLayoutAlign="center center">
                        @if(flow_version.test_ab_count?.length == 0){
                        <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center">
                          <mat-icon class="icon_experiment" svgIcon="icon_experiment"></mat-icon>
                          <div fxHide.lt-md class="test-ab">{{ 'authorization.ab_test_flow' | translate }}</div>
                        </div>
                        }
                        <div class="live">
                          <div class="bullet" [ngClass]="{'success': model.authorization_scheme.active_flows > 0}">
                          </div>
                          <div class="live-txt">{{ 'authorization.live' | translate }}</div>
                        </div>
                      </div>
                    </div>
                    @if(idx < model.authorization_scheme.flows.length - 1){ <hr>
                      }
                      }
                  </div>

                </div>

              </mat-expansion-panel>
              }
            </ng-container>


          </mat-card-content>

          <!-- Footer -->
          <mat-card-footer fxHide.lt-md fxLayout="row" fxLayoutAlign="end space-between">
            <!-- @if(model.has_test_ab){
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
              <div class="test-ab">
                {{ 'authorization.test_ab_message' | translate }}
              </div>
              <div fxLayoutAlign="center center">
                <mat-icon class="icon_experiment-header" svgIcon="icon_experiment"></mat-icon>
              </div>
            </div>
            } -->
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
              @if (state == 'read_only' && !model.has_test_ab) {
              <button mat-mini-fab disableRipple class="icon-button" (click)="edit()">
                <mat-icon class="icon-edit" svgIcon="icon_edit"></mat-icon>
              </button>
              }
              @if(state == 'add' || state == 'editing'){
              <button fxLayoutAlign="end center" fxLayoutAlign.lt-md="center center" mat-flat-button
                [disabled]="invalid" color="primary" (keydown.enter)="confirm()" (click)="confirm()">
                {{ 'authorization.actions.save' | translate}}
              </button>
              }

            </div>
          </mat-card-footer>

        </mat-card>

      </div>

    </div>
  </mat-sidenav>
</mat-sidenav-container>